import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { isLoggedIn, setLocalStore } from "utils/localStorage";
import { useAuthMutation } from "pages/Auth/Auth.query";
import {useSwitchCareHomeMutation,} from "../../../SubAdmins/SubAdmins.query";
import { decryptData, encryptData, getErrorMessage } from "utils/utils";
import { UserModel } from "models";
import { useDispatch } from "react-redux";
import { store_setAuthData } from "pages/Auth/Auth.store";
import API from "service";
import { Alert } from "utils";

const LoginFormLogic = () => {
  const [openCarehomeModal, setOpenCarehomeModal] = useState(false);
  const [loginData, setLoginData] = useState({});
  const {mutate: switchCareHome,} = useSwitchCareHomeMutation();

  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const expired = query.get("expired");

  const history = useHistory();
  // if (isLoggedIn()) history.push("/");

  // Login data
  const [state, setState] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) =>
    setState({ ...state, [e.target.name]: e.target.value });

  // handle login
  const dispatch = useDispatch();
  const { isLoading, mutate: login, error } = useAuthMutation();

  const handleLogin = (e) => {
    e.preventDefault();
    const encrypted = encryptData(state?.password);
    localStorage.setItem("Thriving-auth", encrypted);
    const body = { ...state, username: state.username?.trim() };
    login(body, { onSuccess: onLoginSuccess });
  };
  const onLoginSuccess = (data) => {
    const user = new UserModel(data);
    if (user.type === "subAdmin") {
      dispatch(store_setAuthData(data));

      setLocalStore({
        identifier: data?.identifier,
        token: data?.token,
        dashboardType: data?.dashboardType,
        baseUrl: data?.baseUrl,
        shouldAnonymize: data?.shouldAnonymize,
      });
      localStorage.setItem(
        "subAdmin",
        JSON.stringify({
          id: data.identifier,
          name: data.name,
          email: data.email,
          token: data.token,
        })
      );

      API.setToken(data?.token);
      API.setBaseUrl(data?.baseUrl);

      history.push(`/sub-admin-care-homes/${data.identifier}`);
      return;
    }
    if (data?.careHomes?.length > 0) {
      setOpenCarehomeModal(true);
      localStorage.setItem('user-login-data', JSON.stringify(data))
      setLoginData(data);
      return;
    }
    if (!user.hasAccessToPortal())
      return Alert.error("You don't have access to the portal");

    dispatch(store_setAuthData(data));
    setLocalStore({
      identifier: data?.identifier,
      token: data?.token,
      dashboardType: data?.dashboardType,
      baseUrl: data?.baseUrl,
      shouldAnonymize: data?.shouldAnonymize,
    });
    API.setToken(data?.token);
    API.setBaseUrl(data?.baseUrl);
    history.push("/home");
  };

  const errorMsg = error ? getErrorMessage(error) : "";

  const handleCareHomeModel = () => {
    setOpenCarehomeModal((prev) => !prev);
  };

  const handleSelectChange = (item) => {
    if (!loginData?.careHomes) return;
    if (loginData?.type === "subAdmin") {

      switchCareHome(item.id, {
        onSuccess: (response) => {
          dispatch(store_setAuthData(response));

          setLocalStore({
            identifier: response.careHomeId,
            token: response.token,
            dashboardType: response.dashboardType,
            type: "carehome",
            baseUrl: loginData?.baseUrl,
          });

          API.setToken(response.token);
          API.setBaseUrl(loginData?.baseUrl);

          localStorage.setItem("activeCareHome",
            JSON.stringify({
              id: response.careHomeId,
              name: response.careHomeName,
            })
          );
          localStorage.setItem("isSubAdminContext", "true");

          history.push("/home");
        },
      });

      return;
    }

    const selected = item;

    dispatch(store_setAuthData(selected));
    setLocalStore({
      identifier: selected?.identifier,
      token: selected?.token,
      dashboardType: selected?.dashboardType,
      baseUrl: selected?.baseUrl,
    });
    API.setToken(selected?.token);
    API.setBaseUrl(selected?.baseUrl);
    history.push("/home");
  };

  return {
    expired,
    error,
    isLoading,
    errorMsg,
    handleLogin,
    handleChange,
    handleCareHomeModel,
    handleSelectChange,
    loginData,
    openCarehomeModal,
  };
};

export default LoginFormLogic;
